@if (browsingSkill) {
  <div>
    <div class="m-t-20 m-b-20">
      <button class="fa-button m-b-10" (click)="router.navigate(['../community/connect'])">
        <fa-icon icon="arrow-left" class="m-r-5"></fa-icon>
        {{ "general.go_back" | translate }}
      </button>
      <h4 class="section-header">
        {{ "com.skills." + browsingSkill.string_id | translate }}
      </h4>
      <span class="text-muted">{{ skillMembers.length }}{{ skillMembersHasMore ? "+" : "" }} Members</span>
    </div>
    @if (loadingSkillMembers && !skillMembers.length) {
      <myp-inline-loader [loading]="true" height="200px" spinnerName="skillMembersLoader"></myp-inline-loader>
    }
    @if (skillMembers.length) {
      <div class="row">
        @for (profile of skillMembers; track profile) {
          <div class="col-lg-6 col-xl-4 m-b-10">
            <myp-list-item
              [photo]="profile?.photo ? profile.photo : './assets/images/default_avatar.jpg'"
              [title]="profile.firstName + ' ' + profile.lastName"
              [item]="profile"
              [subData]="[profile.tagline ? profile.tagline : '', profile.skills_string]"
              (itemClicked)="goToProfile(profile)"
            ></myp-list-item>
          </div>
        }
      </div>
      @if (skillMembersHasMore) {
        <div class="text-center m-y-20">
          <button class="btn btn-primary" [disabled]="loadingSkillMembers" (click)="loadMoreSkillMembers()">
            @if (loadingSkillMembers) {
              <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
            }
            {{ "sphere.workspaces.show_more" | translate }}
          </button>
        </div>
      }
    }
    @if (!loadingSkillMembers && !skillMembers.length) {
      <div class="text-center m-y-50">
        <span>{{ "com.no_members_skill" | translate }}</span>
      </div>
    }
  </div>
} @else {
  <div>
    <myp-inline-loader [loading]="!skills || !skills.length" height="200px" spinnerName="connectLoader"></myp-inline-loader>
    @if (skills && skills.length) {
      <div class="m-t-20">
        <h4 class="section-header">
          {{ "com.find_members" | translate }}
        </h4>
        <span class="text-muted">{{ "com.search_by_skill" | translate }}</span>
      </div>
      <div class="item-filter">
        <div class="filter-input no-max-width">
          <input type="text" [(ngModel)]="query" [placeholder]="'com.type_to_search' | translate" />
          @if (query) {
            <div class="clear" (click)="query = ''"><fa-icon icon="times"></fa-icon></div>
          }
        </div>
        @if (query) {
          <div class="connect-autocomplete">
            @for (member of memberResults; track member) {
              @if (member.id) {
                <div class="list-item hover" [routerLink]="['/profile', member.id]">
                  <div class="list-item-container">
                    <img [src]="member.photo || './assets/images/default_avatar.jpg'" class="item-image align-center round image-border" />
                    <div class="main-data">
                      <span class="bold">{{ member.firstName + " " + member.lastName }}</span>
                      <br />
                      <span class="sub-data">
                        @if (member.tagline) {
                          <span>{{ member.tagline }}</span>
                        }
                        @if (member.skillsQueryMap) {
                          <div class="text-muted">
                            {{ "com.skills_word" | translate }}:
                            @for (skill of member.skillsQueryMap; track skill; let i = $index) {
                              <span>{{ communityService.skillsMap[skill]?.title + (i == member.skillsQueryMap.length - 1 ? "" : ",") }}</span>
                            }
                          </div>
                        }
                      </span>
                    </div>
                    <div class="right-data-buttons">
                      <fa-icon icon="chevron-right"></fa-icon>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
      <div class="m-t-20">
        <h4 class="section-header m-b-10 m-t-50">
          {{ "com.browse_by_skill" | translate }}
          <span class="section-header-link" (click)="membersBySkillCollapsed = !membersBySkillCollapsed">
            {{ membersBySkillCollapsed ? ("sphere.expand" | translate | uppercase) : ("sphere.collapse" | translate | uppercase) }}
            <fa-icon [icon]="membersBySkillCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
          </span>
        </h4>
        @if (membersBySkillCollapsed) {
          <div class="text-center">
            <span class="gothic m-y-10">{{ "com.list_collapsed" | translate }}</span>
          </div>
        }
        @if (!membersBySkillCollapsed) {
          <div class="row">
            @for (skill of skills; track skill) {
              <div class="col-lg-6 col-xl-4 m-b-20">
                <div class="p-1 trans-bg border-radius10 h-full">
                  <span class="browse-skill-pill" (click)="browseSkill(skill)" style="cursor: pointer">
                    <span>{{ "com.skills." + skill.string_id | translate }}</span>
                    <fa-icon icon="chevron-right" class="m-l-5"></fa-icon>
                  </span>
                  @if (membersBySkillSample[skill.string_id] && membersBySkillSample[skill.string_id].length) {
                    @for (profile of membersBySkillSample[skill.string_id]; track profile) {
                      <myp-list-item
                        [photo]="profile?.photo ? profile.photo : './assets/images/default_avatar.jpg'"
                        [title]="profile.firstName + ' ' + profile.lastName"
                        [item]="profile"
                        [subData]="[profile.tagline ? profile.tagline : '', profile.skills_string]"
                        (itemClicked)="goToProfile(profile)"
                      ></myp-list-item>
                    }
                  }
                  @if (!membersBySkillSample[skill.string_id] || !membersBySkillSample[skill.string_id].length) {
                    <div class="text-center m-t-20 p-x-20">
                      <span class="t-12">{{ "com.no_members_skill" | translate }}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
